import React from 'react';
import PropTypes from 'prop-types';
import './ImageCenter.scss';

/**
 * The only true button.
 */
const ImageCenter = ({ url, align = '', alt }) => (
  <div className={`component-image-center ${align}`}>
    <img src={url} alt={alt} />
  </div>
);

ImageCenter.propTypes = {
  url: PropTypes.string.isRequired,
  align: PropTypes.string,
  alt: PropTypes.string
};

ImageCenter.defaultProps = {
  align: '',
  alt: ''
};

export default ImageCenter;



// WEBPACK FOOTER //
// ./src/components/ImageCenter/ImageCenter.jsx